import {useState} from 'react'
import { toast } from "react-toastify";
import DeletePopup from '../../../../common/components/DeletePopup';
import RefundModal from '../SingleOrder/components/Modal/RefundModal';

const OrderActions = ({order , setOrder}) => {
    const [isActionOpen, setIsActionOpen] = useState(false);
    const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
    const [isRefundOpen, setIsRefundOpen] = useState(false);
    const buttonClass = 'group px-3 flex items-center gap-2 py-2 text-left duration-300 text-[14px] font-normal leading-[26px] cursor-pointer rounded-[4px] m-0'

    const deleteAction = () => {
        easycommerce_modal(true);

        fetch(
            `${EASYCOMMERCE.rest_base}/orders/${order.id}`,
            {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": EASYCOMMERCE.nonce,
                }
            }
        )
            .then((res) => res.json())
            .then((order) => {
                easycommerce_modal(false);

                if (order.success) {
                    toast.success('Order Deleted!');
                    window.location.hash = `#/orders`;
                }
            });
    };

    return (
        <div className='relative'>
            <button 
                type="button" 
                className="h-[41px] w-[30px] flex items-center justify-center rounded-lg border border-ec-table-stock cursor-pointer"
                onClick={() => setIsActionOpen(prev => !prev)}
                onBlur={() => {
                    setTimeout(() => setIsActionOpen(false), 500)
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="20" viewBox="0 0 4 20" fill="none">
                    <circle cx="1.99609" cy="1.99976" r="2" transform="rotate(90 1.99609 1.99976)" fill="#3C3C42"/>
                    <circle cx="1.99609" cy="9.99976" r="2" transform="rotate(90 1.99609 9.99976)" fill="#3C3C42"/>
                    <circle cx="1.99609" cy="17.9998" r="2" transform="rotate(90 1.99609 17.9998)" fill="#3C3C42"/>
                </svg>
            </button>

            {isActionOpen && 
                <div className="border w-[120px] bg-white border-ec-border rounded-lg shadow-2xl p-2 font-inter flex flex-col absolute top-[48px]">
                    <a className={buttonClass + ' text-ec-body hover:bg-[#F8F8F8]'}
                        onClick={() => {
                            setIsRefundOpen(true);
                            setIsActionOpen(false);
                        }}
                    >
                        Refund
                    </a>
                    <button 
                        type='button' 
                        className={buttonClass + ' text-[#FF3A52] hover:bg-[#FF3A520D]'}
                        onClick={() => setIsDeletePopupOpen(true)}
                    >
                        Delete
                    </button>
                </div>
            }

            {isDeletePopupOpen && 
                <DeletePopup
                    onClose={() => setIsDeletePopupOpen(false)}
                    itemName={"Order #"+order.id}
                    onConfirm={() => deleteAction()}
                />
            }

            {isRefundOpen &&
                <RefundModal
                    order={order}
                    hideModal={() => setIsRefundOpen(false)}
                    updateOrder={(order) => setOrder(order)}
                />
            }
        </div>
    )
}

export default OrderActions;